<template>
    <div id="wrapper">
      <Sidebar></Sidebar>
      <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">

        <!-- Main Content -->
        <div id="content">

          <Topbar></Topbar>
          <!-- Begin Page Content -->
          <div class="container-fluid">

            <!-- Page Heading -->
            <router-link :to="{ name: 'Home'}" > CRCB Control Panel</router-link> >   
            <span>英文版聯絡表單管理</span>

            <h1 class="h3 mb-2 mt-2 text-gray-800">英文版聯絡表單管理</h1>
            <div class="text-center" v-if="loading" >
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>  

            <!-- DataTales Example -->
            <div class="card shadow mb-4" v-if="!loading">
              <div class="card-header py-3">
              <button type="button" class="btn btn-primary" v-on:click="ExportCsv">匯出</button>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                      <tr>
                        <th>日期</th>
                        <th>姓名</th>
                        <th>主旨</th>
                        <th>功能</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item) in datas" :key="item.id">
                        <td>{{item.data.date}}</td>
                        <td>{{item.data.name}}</td>
                        <td>{{item.data.title}}</td>
                        <td>
                          <button type="button" class="btn btn-primary" v-on:click="EditUser(item.id)">檢視</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

          </div>
          <!-- /.container-fluid -->

        </div>
        <!-- End of Main Content -->

        <Footer></Footer>

      </div>
      <!-- End of Content Wrapper -->
    </div>
</template>

<script>
import Sidebar from './shared/Sidebar'
import Topbar from './shared/Topbar'
import Footer from './shared/Footer'
import {fb, db } from '../firebase'
import moment from 'moment'
export default {
  name: 'User',
  components: {
    Sidebar,Topbar,Footer
  },
  data () {
    return {
      datas:[],
      loading:true
    }
  },
  mounted () {
    this.Get();
  },
  methods: {
    Get(){
        this.users = [];
        // 取得列表
        db.collection("contact_en").get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                var data = {"id": doc.id, "data": doc.data()};
                
                this.datas.push(data);
            });
            this.datas.sort( (d1, d2) =>  new Date(d2.data.date) - new Date( d1.data.date));
            this.loading = false;
            this.EnableTable();
            
        });
    },
    EditUser(id) {
      this.$router.push({name: 'Contact_enEdit', params: { id: id }});
    },
    DeleteUser(id) {
      if ( confirm("確定要刪除?") ) {
        db.collection("contact_en").doc(id).delete()
        .then(() => {
            alert("刪除成功!");
            this.Get();
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
      }
    },
    BuildData() {
      return new Promise((resolve, reject) => {

        // 最後所有的資料會存在這
        let arrayData = [];

        try {
          // 取 data 的第一個 Object 的 key 當表頭
          let arrayTitle = ['姓名','公司名稱','電話','E-mail','日期','主旨','內容']
          arrayData.push(arrayTitle);

          // 取出每一個 Object 裡的 value，push 進新的 Array 裡
          Array.prototype.forEach.call(this.datas, d => {
            let items = [];
            items.push(d.data.name);
            items.push(d.data.company);
            items.push(d.data.phone);
            items.push(d.data.email);
            items.push(d.data.date);
            items.push(d.data.title);
            items.push(d.data.desc);
            arrayData.push(items);
          });

          console.log(arrayData);
        } catch(err) {
          console.log(err);
          reject(err)
        }

        resolve(arrayData);
      })

    },
    DownloadCSV(data) {
      let csvContent = '';
      Array.prototype.forEach.call(data, d => {
        let dataString = d.join(',') + '\n';
        csvContent += dataString;
      })

      // 下載的檔案名稱
      let fileName = moment((new Date()).getTime()).format('YYYY_MM_DD_HH_mm_ss') + '.csv';

      // 建立一個 a，並點擊它
      let link = document.createElement('a');
      link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csvContent));
      link.setAttribute('download', fileName);
      link.click();
    },
    ExportCsv() {
      var vm = this;
      try {
        this.BuildData()
          .then(data => vm.DownloadCSV(data))
          .catch(console.log('fail..'));
      } catch(err) {
        window.alert(err)
      } 
    }
  }
}
</script>
<style scoped>
th,td {
  border-top:1px solid #e3e6f0 !important;
  border-bottom: 0px;
  border-left: 0px;
  border-right: 0px;
}
th:last-child,td:last-child {
  border-right:1px solid #e3e6f0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ContactEN.vue